<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'AI_ASSISTANT.TESTING.SUITE_MODAL.NAME_LABEL' | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        [placeholder]="'AI_ASSISTANT.TESTING.SUITE_MODAL.NAME_PLACEHOLDER' | translate"
      />
      @if (form.get('name')?.hasError('required')) {
        <mat-error>{{ 'AI_ASSISTANT.TESTING.SUITE_MODAL.NAME_REQUIRED' | translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        formControlName="description"
        placeholder="Describe the purpose of this test suite"
        rows="3"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Tags</mat-label>
      <mat-chip-grid #tagChipGrid>
        @for (tag of form.controls.tags.value; track $index) {
          <mat-chip-row (removed)="removeTag(tag)">
            {{ tag }}
            <button matChipRemove [attr.aria-label]="'remove ' + tag">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          placeholder="Add tag..."
          (matChipInputTokenEnd)="addTagFromInput($event)"
          [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
          [matChipInputFor]="tagChipGrid"
          [matChipInputAddOnBlur]="true"
        />
      </mat-chip-grid>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!form.valid">
    {{ submitButtonText }}
  </button>
</mat-dialog-actions>
